import { PhotoGsd    } from "./Network"; 
import { AbandonedVehicleReviewStatus    } from "./Network"; 
import { AbandonedVehicleStatus    } from "./Network"; 
import { PasswordResetType    } from "./Network"; 
import { VehicleSituation    } from "./Network"; import { AerialImageApi } from "./Network"; 
import { AerialImagePairOffsetApi } from "./Network"; 
import { AiStructuredResponseApi } from "./Network"; 
import { CadModelAttributesApi } from "./Network"; 
import { CadModelApi } from "./Network"; 
import { ChicagoAbandonedVehicleApi } from "./Network"; 
import { CreateAerialImageApi } from "./Network"; 
import { DatasetApi } from "./Network"; 
import { DatasetImageApi } from "./Network"; 
import { DatasetStatsApi } from "./Network"; 
import { DumpTrainingDataRespApi } from "./Network"; 
import { EmployeeApi } from "./Network"; 
import { LoginResponseApi } from "./Network"; 
import { MunicipalityApi } from "./Network"; 
import { ObbAnnotationAttributesApi } from "./Network"; 
import { ObbAnnotationApi } from "./Network"; 
import { ObbClassApi } from "./Network"; 
import { ObbDetApi } from "./Network"; 
import { ObbDetCompApi } from "./Network"; 
import { ObbModelApi } from "./Network"; 
import { AbandonedVehicleRunApi } from "./Network"; 
import { ObbRunApi } from "./Network"; 
import { RepoAddressApi } from "./Network"; 
import { RepoSearchReqApi } from "./Network"; 
import { RepoSearchRespApi } from "./Network"; 
import { VehicleDataApi } from "./Network"; 
import { AddressDataApi } from "./Network"; 
import { DateTestApi } from "./Network"; 
import { ResolvedAddressApi } from "./Network"; 
import { UpdateAerialImageApi } from "./Network"; 
import { VehicleApi } from "./Network"; 
import { AbandonedVehicleApi } from "./Network"; 
import { AbandonedVehicleAttributesApi } from "./Network"; 
import { AbandonedVehicleAttributesCompressedApi } from "./Network"; 
import { AbandonedVehicleChangeApi } from "./Network"; 
import { AbandonedVehicleChangeCompressedApi } from "./Network"; 
import { AbandonedVehicleCompressedApi } from "./Network"; 
import { AbandonedVehicleReviewChangeApi } from "./Network"; 
import { AbandonedVehicleReviewChangeCompressedApi } from "./Network"; 
import { AbandonedVehicleUpdateReqApi } from "./Network"; 
import { AbandonedVehicleReviewUpdateReqApi } from "./Network"; 
import { AbandonedVehicleUpdateAttrReqApi } from "./Network"; 
import { AbandonedVehicleCreateReqApi } from "./Network"; 
import { LoginReqApi } from "./Network"; 
import { RegisterReqApi } from "./Network"; 
import { ForgotPasswordReqApi } from "./Network"; 
import { ResetPasswordReqApi } from "./Network"; 
import { ChangePasswordReqApi } from "./Network"; 
import { ChangeEmailReqApi } from "./Network"; 
import { ChangeNameReqApi } from "./Network"; 
import { LoginRespApi } from "./Network"; 
import { ResetPasswordCheckReqApi } from "./Network"; 
import { CadModelUpdateAttributesReqApi } from "./Network"; 
import { DatasetCreateReqApi } from "./Network"; 
import { DatasetRespApi } from "./Network"; 
import { DatasetImageAddRespApi } from "./Network"; 
import { DatasetImageObjectAddReqApi } from "./Network"; 
import { TileAerialImageReqApi } from "./Network"; 
import { TleRecApi } from "./Network"; 
import { SatelliteInfoApi } from "./Network"; 
import { TleReqApi } from "./Network"; 
import { TileResponseApi } from "./Network"; import { AerialImage } from "./Application"; 
import { AerialImagePairOffset } from "./Application"; 
import { AiStructuredResponse } from "./Application"; 
import { CadModelAttributes } from "./Application"; 
import { CadModel } from "./Application"; 
import { ChicagoAbandonedVehicle } from "./Application"; 
import { CreateAerialImage } from "./Application"; 
import { Dataset } from "./Application"; 
import { DatasetImage } from "./Application"; 
import { DatasetStats } from "./Application"; 
import { DumpTrainingDataResp } from "./Application"; 
import { Employee } from "./Application"; 
import { LoginResponse } from "./Application"; 
import { Municipality } from "./Application"; 
import { ObbAnnotationAttributes } from "./Application"; 
import { ObbAnnotation } from "./Application"; 
import { ObbClass } from "./Application"; 
import { ObbDet } from "./Application"; 
import { ObbDetComp } from "./Application"; 
import { ObbModel } from "./Application"; 
import { AbandonedVehicleRun } from "./Application"; 
import { ObbRun } from "./Application"; 
import { RepoAddress } from "./Application"; 
import { RepoSearchReq } from "./Application"; 
import { RepoSearchResp } from "./Application"; 
import { VehicleData } from "./Application"; 
import { AddressData } from "./Application"; 
import { DateTest } from "./Application"; 
import { ResolvedAddress } from "./Application"; 
import { UpdateAerialImage } from "./Application"; 
import { Vehicle } from "./Application"; 
import { AbandonedVehicle } from "./Application"; 
import { AbandonedVehicleAttributes } from "./Application"; 
import { AbandonedVehicleAttributesCompressed } from "./Application"; 
import { AbandonedVehicleChange } from "./Application"; 
import { AbandonedVehicleChangeCompressed } from "./Application"; 
import { AbandonedVehicleCompressed } from "./Application"; 
import { AbandonedVehicleReviewChange } from "./Application"; 
import { AbandonedVehicleReviewChangeCompressed } from "./Application"; 
import { AbandonedVehicleUpdateReq } from "./Application"; 
import { AbandonedVehicleReviewUpdateReq } from "./Application"; 
import { AbandonedVehicleUpdateAttrReq } from "./Application"; 
import { AbandonedVehicleCreateReq } from "./Application"; 
import { LoginReq } from "./Application"; 
import { RegisterReq } from "./Application"; 
import { ForgotPasswordReq } from "./Application"; 
import { ResetPasswordReq } from "./Application"; 
import { ChangePasswordReq } from "./Application"; 
import { ChangeEmailReq } from "./Application"; 
import { ChangeNameReq } from "./Application"; 
import { LoginResp } from "./Application"; 
import { ResetPasswordCheckReq } from "./Application"; 
import { CadModelUpdateAttributesReq } from "./Application"; 
import { DatasetCreateReq } from "./Application"; 
import { DatasetResp } from "./Application"; 
import { DatasetImageAddResp } from "./Application"; 
import { DatasetImageObjectAddReq } from "./Application"; 
import { TileAerialImageReq } from "./Application"; 
import { TleRec } from "./Application"; 
import { SatelliteInfo } from "./Application"; 
import { TleReq } from "./Application"; 
import { TileResponse } from "./Application"; 
import { parseInstant,parseLocalDate,parseLocalTime,parseLocalDateTime,parseDuration } from "./Converters";

export function parseAerialImage( x: AerialImageApi ): AerialImage {
    return {
        aerialImageId: x.aerialImageId,
        aerialProviderId: x.aerialProviderId,
        name: x.name,
        filePath: x.filePath,
        fileSize: x.fileSize,
        contentType: x.contentType,
        capturedWhen: parseInstant( x.capturedWhen ),
        originX: x.originX,
        pixelWidth: x.pixelWidth,
        rotationX: x.rotationX,
        originY: x.originY,
        rotationY: x.rotationY,
        pixelHeight: x.pixelHeight,
        epsgCode: x.epsgCode,
        width: x.width,
        height: x.height,
        minX: x.minX,
        minY: x.minY,
        maxX: x.maxX,
        maxY: x.maxY,
    }
}

export function parseAerialImagePairOffset( x: AerialImagePairOffsetApi ): AerialImagePairOffset {
    return {
        aerialImagePairOffsetId: x.aerialImagePairOffsetId,
        aerialImageBeforeId: x.aerialImageBeforeId,
        aerialImageAfterId: x.aerialImageAfterId,
        offsetX: x.offsetX,
        offsetY: x.offsetY,
    }
}

export function parseAiStructuredResponse( x: AiStructuredResponseApi ): AiStructuredResponse {
    return {
        vehicle: parseVehicle( x.vehicle ),
        addresses: x.addresses.map( el => parseRepoAddress( el ) ),
    }
}

export function parseCadModelAttributes( x: CadModelAttributesApi ): CadModelAttributes {
    return {
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
    }
}

export function parseCadModel( x: CadModelApi ): CadModel {
    return {
        id: x.id,
        modelId: x.modelId,
        collectionId: x.collectionId,
        modelName: x.modelName != null ? x.modelName : null,
        description: x.description != null ? x.description : null,
        issue: x.issue != null ? x.issue : null,
        carMake: x.carMake != null ? x.carMake : null,
        carYear: x.carYear != null ? x.carYear : null,
        carModel: x.carModel != null ? x.carModel : null,
        dimsL: x.dimsL != null ? x.dimsL : null,
        dimsW: x.dimsW != null ? x.dimsW : null,
        dimsH: x.dimsH != null ? x.dimsH : null,
        color: x.color != null ? x.color : null,
        domain: x.domain != null ? x.domain : null,
        type1: x.type1 != null ? x.type1 : null,
        url: x.url != null ? x.url : null,
        error: x.error != null ? x.error : null,
        comment: x.comment != null ? x.comment : null,
        attributes: parseCadModelAttributes( x.attributes ),
    }
}

export function parseChicagoAbandonedVehicle( x: ChicagoAbandonedVehicleApi ): ChicagoAbandonedVehicle {
    return {
        lat: x.lat != null ? x.lat : null,
        lng: x.lng != null ? x.lng : null,
        date: x.date != null ? parseInstant( x.date ) : null,
    }
}

export function parseCreateAerialImage( x: CreateAerialImageApi ): CreateAerialImage {
    return {
        fileName: x.fileName,
        filePath: x.filePath,
        location: x.location,
        capturedAt: x.capturedAt != null ? parseInstant( x.capturedAt ) : null,
        resolution: x.resolution,
        width: x.width,
        height: x.height,
        fileSize: x.fileSize,
        tags: x.tags != null ? x.tags.map( el => el ) : null,
    }
}

export function parseDataset( x: DatasetApi ): Dataset {
    return {
        datasetId: x.datasetId,
        name: x.name,
        description: x.description != null ? x.description : null,
        count: x.count,
    }
}

export function parseDatasetImage( x: DatasetImageApi ): DatasetImage {
    return {
        datasetImageId: x.datasetImageId,
        datasetId: x.datasetId,
        name: x.name,
        filePath: x.filePath,
        width: x.width,
        height: x.height,
        objectCount: x.objectCount,
        annotatedCount: x.annotatedCount,
        epsgCode: x.epsgCode != null ? x.epsgCode : null,
        originX: x.originX != null ? x.originX : null,
        originY: x.originY != null ? x.originY : null,
        pixelWidth: x.pixelWidth != null ? x.pixelWidth : null,
        pixelHeight: x.pixelHeight != null ? x.pixelHeight : null,
        rotationX: x.rotationX != null ? x.rotationX : null,
        rotationY: x.rotationY != null ? x.rotationY : null,
        minX: x.minX != null ? x.minX : null,
        minY: x.minY != null ? x.minY : null,
        maxX: x.maxX != null ? x.maxX : null,
        maxY: x.maxY != null ? x.maxY : null,
    }
}

export function parseDatasetStats( x: DatasetStatsApi ): DatasetStats {
    return {
        datasetId: x.datasetId,
        imageCount: x.imageCount,
        vehicleCount: x.vehicleCount,
        vehicleTypeStats: x.vehicleTypeStats.map( el => el ),
        vehicleColorStats: x.vehicleColorStats.map( el => el ),
    }
}

export function parseDumpTrainingDataResp( x: DumpTrainingDataRespApi ): DumpTrainingDataResp {
    return {
        classCounts: x.classCounts.map( el => el ),
        total: x.total,
        errors: x.errors,
    }
}

export function parseEmployee( x: EmployeeApi ): Employee {
    return {
        employeeId: x.employeeId,
        municipalityId: x.municipalityId,
        emailAddress: x.emailAddress,
        name: x.name,
        municipality: parseMunicipality( x.municipality ),
    }
}

export function parseLoginResponse( x: LoginResponseApi ): LoginResponse {
    return {
        token: x.token,
        employee: parseEmployee( x.employee ),
    }
}

export function parseMunicipality( x: MunicipalityApi ): Municipality {
    return {
        municipalityId: x.municipalityId,
        name: x.name,
    }
}

export function parseObbAnnotationAttributes( x: ObbAnnotationAttributesApi ): ObbAnnotationAttributes {
    return {
        classLabel: x.classLabel != null ? x.classLabel : null,
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
        color: x.color != null ? x.color : null,
        parts: x.parts != null ? x.parts.map( el => el ) : null,
        shade: x.shade != null ? x.shade : null,
        occluded: x.occluded != null ? x.occluded : null,
        rare: x.rare != null ? x.rare : null,
    }
}

export function parseObbAnnotation( x: ObbAnnotationApi ): ObbAnnotation {
    return {
        obbAnnotationId: x.obbAnnotationId,
        datasetImageId: x.datasetImageId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        attributes: parseObbAnnotationAttributes( x.attributes ),
    }
}

export function parseObbClass( x: ObbClassApi ): ObbClass {
    return {
        obbClassId: x.obbClassId,
        name: x.name,
    }
}

export function parseObbDet( x: ObbDetApi ): ObbDet {
    return {
        obbDetId: x.obbDetId,
        obbRunId: x.obbRunId,
        obbModelId: x.obbModelId,
        obbClassId: x.obbClassId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        confidence: x.confidence,
    }
}

export function parseObbDetComp( x: ObbDetCompApi ): ObbDetComp {
    return {
        id: x.id,
        cls: x.cls,
        x: x.x,
        y: x.y,
        w: x.w,
        h: x.h,
        a: x.a,
        c: x.c,
    }
}

export function parseObbModel( x: ObbModelApi ): ObbModel {
    return {
        obbModelId: x.obbModelId,
        name: x.name,
    }
}

export function parseAbandonedVehicleRun( x: AbandonedVehicleRunApi ): AbandonedVehicleRun {
    return {
        abandonedVehicleRunId: x.abandonedVehicleRunId,
        aerialImageBeforeId: x.aerialImageBeforeId,
        aerialImageAfterId: x.aerialImageAfterId,
        before: parseAerialImage( x.before ),
        after: parseAerialImage( x.after ),
        createdWhen: parseInstant( x.createdWhen ),
    }
}

export function parseObbRun( x: ObbRunApi ): ObbRun {
    return {
        obbRunId: x.obbRunId,
        aerialImageId: x.aerialImageId,
        obbModelId: x.obbModelId,
        createdByEmployeeId: x.createdByEmployeeId,
        createdWhen: parseInstant( x.createdWhen ),
        notes: x.notes != null ? x.notes : null,
    }
}

export function parseRepoAddress( x: RepoAddressApi ): RepoAddress {
    return {
        addressLine1: x.addressLine1,
        addressLine2: x.addressLine2,
        city: x.city,
        state: x.state,
        zipCode: x.zipCode,
    }
}

export function parseRepoSearchReq( x: RepoSearchReqApi ): RepoSearchReq {
    return {
        vehiclePrompt: x.vehiclePrompt,
        addressesPrompt: x.addressesPrompt,
    }
}

export function parseRepoSearchResp( x: RepoSearchRespApi ): RepoSearchResp {
    return {
        vehicle: parseVehicleData( x.vehicle ),
        addresses: x.addresses.map( el => parseAddressData( el ) ),
    }
}

export function parseVehicleData( x: VehicleDataApi ): VehicleData {
    return {
        make: x.make,
        model: x.model,
        color: x.color != null ? x.color : null,
        year: x.year != null ? x.year : null,
    }
}

export function parseAddressData( x: AddressDataApi ): AddressData {
    return {
        streetNumber: x.streetNumber != null ? x.streetNumber : null,
        street: x.street != null ? x.street : null,
        city: x.city != null ? x.city : null,
        state: x.state != null ? x.state : null,
        postalCode: x.postalCode != null ? x.postalCode : null,
    }
}

export function parseDateTest( x: DateTestApi ): DateTest {
    return {
        when: parseInstant( x.when ),
        when1: parseLocalDate( x.when1 ),
        when2: parseLocalTime( x.when2 ),
        when3: parseLocalDateTime( x.when3 ),
        dur1: parseDuration( x.dur1 ),
    }
}

export function parseResolvedAddress( x: ResolvedAddressApi ): ResolvedAddress {
    return {
        addressId: x.addressId,
        fullAddress: x.fullAddress,
        streetNumber: x.streetNumber != null ? x.streetNumber : null,
        street: x.street != null ? x.street : null,
        city: x.city != null ? x.city : null,
        state: x.state != null ? x.state : null,
        postalCode: x.postalCode != null ? x.postalCode : null,
        country: x.country != null ? x.country : null,
        latitude: x.latitude != null ? x.latitude : null,
        longitude: x.longitude != null ? x.longitude : null,
        resolvedWhen: parseInstant( x.resolvedWhen ),
    }
}

export function parseUpdateAerialImage( x: UpdateAerialImageApi ): UpdateAerialImage {
    return {
        location: x.location != null ? x.location : null,
        processingStatus: x.processingStatus != null ? x.processingStatus : null,
        tags: x.tags != null ? x.tags.map( el => el ) : null,
    }
}

export function parseVehicle( x: VehicleApi ): Vehicle {
    return {
        vehicleId: x.vehicleId,
        make: x.make,
        model: x.model,
        color: x.color != null ? x.color : null,
        year: x.year != null ? x.year : null,
    }
}

export function parseAbandonedVehicle( x: AbandonedVehicleApi ): AbandonedVehicle {
    return {
        abandonedVehicleId: x.abandonedVehicleId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        confidence: x.confidence,
        similarity: x.similarity,
        status: parseAbandonedVehicleChange( x.status ),
        reviewStatus: x.reviewStatus != null ? parseAbandonedVehicleReviewChange( x.reviewStatus ) : null,
        note: x.note,
        attributes: parseAbandonedVehicleAttributes( x.attributes ),
        changes: x.changes.map( el => parseAbandonedVehicleChange( el ) ),
        reviews: x.reviews.map( el => parseAbandonedVehicleReviewChange( el ) ),
    }
}

export function parseAbandonedVehicleAttributes( x: AbandonedVehicleAttributesApi ): AbandonedVehicleAttributes {
    return {
        landUse: x.landUse != null ? x.landUse : null,
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
        situation: x.situation != null ? x.situation : null,
        area: x.area != null ? x.area : null,
        address: x.address != null ? x.address : null,
    }
}

export function parseAbandonedVehicleAttributesCompressed( x: AbandonedVehicleAttributesCompressedApi ): AbandonedVehicleAttributesCompressed {
    return {
        lu: x.lu != null ? x.lu : null,
        vt: x.vt != null ? x.vt : null,
        si: x.si != null ? x.si : null,
        ar: x.ar != null ? x.ar : null,
        ad: x.ad != null ? x.ad : null,
    }
}

export function parseAbandonedVehicleChange( x: AbandonedVehicleChangeApi ): AbandonedVehicleChange {
    return {
        abandonedVehicleChangeId: x.abandonedVehicleChangeId,
        abandonedVehicleId: x.abandonedVehicleId,
        note: x.note,
        status: x.status,
        createdWhen: parseInstant( x.createdWhen ),
        createdBy: x.createdBy != null ? parseEmployee( x.createdBy ) : null,
    }
}

export function parseAbandonedVehicleChangeCompressed( x: AbandonedVehicleChangeCompressedApi ): AbandonedVehicleChangeCompressed {
    return {
        c: x.c,
        d: parseInstant( x.d ),
    }
}

export function parseAbandonedVehicleCompressed( x: AbandonedVehicleCompressedApi ): AbandonedVehicleCompressed {
    return {
        a: x.a,
        x: x.x,
        y: x.y,
        w: x.w,
        h: x.h,
        t: x.t,
        c: x.c,
        s: x.s,
        at: parseAbandonedVehicleAttributesCompressed( x.at ),
        st: parseAbandonedVehicleChangeCompressed( x.st ),
        rs: x.rs != null ? parseAbandonedVehicleReviewChangeCompressed( x.rs ) : null,
    }
}

export function parseAbandonedVehicleReviewChange( x: AbandonedVehicleReviewChangeApi ): AbandonedVehicleReviewChange {
    return {
        abandonedVehicleReviewChangeId: x.abandonedVehicleReviewChangeId,
        abandonedVehicleId: x.abandonedVehicleId,
        note: x.note,
        status: x.status,
        createdWhen: parseInstant( x.createdWhen ),
        createdBy: parseEmployee( x.createdBy ),
    }
}

export function parseAbandonedVehicleReviewChangeCompressed( x: AbandonedVehicleReviewChangeCompressedApi ): AbandonedVehicleReviewChangeCompressed {
    return {
        c: x.c,
        d: parseInstant( x.d ),
    }
}

export function parseAbandonedVehicleUpdateReq( x: AbandonedVehicleUpdateReqApi ): AbandonedVehicleUpdateReq {
    return {
        note: x.note,
        status: x.status,
    }
}

export function parseAbandonedVehicleReviewUpdateReq( x: AbandonedVehicleReviewUpdateReqApi ): AbandonedVehicleReviewUpdateReq {
    return {
        note: x.note,
        status: x.status,
    }
}

export function parseAbandonedVehicleUpdateAttrReq( x: AbandonedVehicleUpdateAttrReqApi ): AbandonedVehicleUpdateAttrReq {
    return {
        situation: x.situation != null ? x.situation : null,
    }
}

export function parseAbandonedVehicleCreateReq( x: AbandonedVehicleCreateReqApi ): AbandonedVehicleCreateReq {
    return {
        runId: x.runId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
    }
}

export function parseLoginReq( x: LoginReqApi ): LoginReq {
    return {
        emailAddress: x.emailAddress,
        password: x.password,
    }
}

export function parseRegisterReq( x: RegisterReqApi ): RegisterReq {
    return {
        businessId: x.businessId,
        emailAddress: x.emailAddress,
        name: x.name,
        password: x.password,
        note: x.note,
    }
}

export function parseForgotPasswordReq( x: ForgotPasswordReqApi ): ForgotPasswordReq {
    return {
        emailAddress: x.emailAddress,
    }
}

export function parseResetPasswordReq( x: ResetPasswordReqApi ): ResetPasswordReq {
    return {
        email: x.email,
        resetCode: x.resetCode,
        newPassword: x.newPassword,
    }
}

export function parseChangePasswordReq( x: ChangePasswordReqApi ): ChangePasswordReq {
    return {
        currentPassword: x.currentPassword,
        newPassword: x.newPassword,
    }
}

export function parseChangeEmailReq( x: ChangeEmailReqApi ): ChangeEmailReq {
    return {
        currentPassword: x.currentPassword,
        newEmailAddress: x.newEmailAddress,
    }
}

export function parseChangeNameReq( x: ChangeNameReqApi ): ChangeNameReq {
    return {
        name: x.name,
    }
}

export function parseLoginResp( x: LoginRespApi ): LoginResp {
    return {
        token: x.token,
        employee: parseEmployee( x.employee ),
    }
}

export function parseResetPasswordCheckReq( x: ResetPasswordCheckReqApi ): ResetPasswordCheckReq {
    return {
        resetCode: x.resetCode,
    }
}

export function parseCadModelUpdateAttributesReq( x: CadModelUpdateAttributesReqApi ): CadModelUpdateAttributesReq {
    return {
        attributes: parseCadModelAttributes( x.attributes ),
    }
}

export function parseDatasetCreateReq( x: DatasetCreateReqApi ): DatasetCreateReq {
    return {
        name: x.name,
        description: x.description != null ? x.description : null,
    }
}

export function parseDatasetResp( x: DatasetRespApi ): DatasetResp {
    return {
        datasetId: x.datasetId,
        name: x.name,
        description: x.description != null ? x.description : null,
    }
}

export function parseDatasetImageAddResp( x: DatasetImageAddRespApi ): DatasetImageAddResp {
    return {
        datasetImageId: x.datasetImageId,
    }
}

export function parseDatasetImageObjectAddReq( x: DatasetImageObjectAddReqApi ): DatasetImageObjectAddReq {
    return {
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        attributes: parseObbAnnotationAttributes( x.attributes ),
    }
}

export function parseTileAerialImageReq( x: TileAerialImageReqApi ): TileAerialImageReq {
    return {
        aerialImageId: x.aerialImageId,
        datasetName: x.datasetName,
        tileSize: x.tileSize,
        overlapPercentage: x.overlapPercentage,
    }
}

export function parseTleRec( x: TleRecApi ): TleRec {
    return {
        twoLineElementId: x.twoLineElementId,
        satelliteId: x.satelliteId,
        noradCatId: x.noradCatId,
        epoch: parseInstant( x.epoch ),
        line1: x.line1,
        line2: x.line2,
    }
}

export function parseSatelliteInfo( x: SatelliteInfoApi ): SatelliteInfo {
    return {
        satelliteId: x.satelliteId,
        noradCatId: x.noradCatId,
        name: x.name,
    }
}

export function parseTleReq( x: TleReqApi ): TleReq {
    return {
        noradCatIds: x.noradCatIds.map( el => el ),
    }
}

export function parseTileResponse( x: TileResponseApi ): TileResponse {
    return {
        message: x.message,
        tilesGenerated: x.tilesGenerated,
        tilesSkipped: x.tilesSkipped,
        outputPath: x.outputPath,
        zoomLevels: x.zoomLevels,
        minZoom: x.minZoom,
        maxZoom: x.maxZoom,
        imageWidth: x.imageWidth,
        imageHeight: x.imageHeight,
    }
}
